export default __webpack_public_path__ + "static/media/excluir-button.fc3807f4.svg";